import { startApp } from "./app";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => startApp());
} else {
  startApp();
}
